module.exports = __webpack_public_path__ + "img/428.fa0d9dd4.jpg";